import { Component, OnInit, Output, EventEmitter, Input, HostListener} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { LookupItem } from 'src/app/shared/lookup-item.model';
import { PotGear } from 'src/app/shared/pot-gear.model';
import { lookupItemValidator } from 'src/app/shared/trip-validator.model';

/**
 * Pot form to display in gear-select-dialog
 */
@Component({
    selector: 'app-pot-form',
    templateUrl: './pot-form.component.html',
    styleUrls: ['./pot-form.component.css'],
    standalone: false
})
export class PotFormComponent implements OnInit {

  // back to gear type
  @Output() cancelEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output() gearAddEvent = new EventEmitter<PotGear>();

  /* Form controls */
  potForm = new FormGroup({
    name: new FormControl(''),
    potType: new FormControl(new LookupItem(''), [Validators.required, lookupItemValidator()]),
    height: new FormControl('', Validators.required),
    width: new FormControl('', Validators.required),
    length: new FormControl('', Validators.required),
    spacing: new FormControl('', Validators.required),
    holeSize: new FormControl('', Validators.required),
    numHoles: new FormControl('', Validators.required)
  });

  @Input() pot: PotGear = new PotGear();

  @Input() potTypes: LookupItem[] = [];

  @Input() isEdit: boolean = false;

  constructor() { }

  ngOnInit(): void {

  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Enter') this.onConfirmBtnClick()
  }

  onConfirmBtnClick() {
    if (this.potForm.valid) {
      let form = this.potForm.value;

      let newPot = new PotGear();
      //Form must be validated before this
      if (this.isEdit) newPot.identifier = form.name as string;
      newPot.gearSubtype = form.potType!;
      newPot.potHeight = Number.parseInt(form.height!);
      newPot.potWidth = Number.parseInt(form.width!);
      newPot.potLength = Number.parseInt(form.length!);
      newPot.spacing = Number.parseInt(form.spacing!);
      newPot.escapeHoleSize = Number.parseInt(form.holeSize!);
      newPot.escapeHoleCount = Number.parseInt(form.numHoles!);

      this.gearAddEvent.emit(newPot);
    }
    this.potForm.markAllAsTouched();
  }


  ngOnChanges() {
    if (!this.pot.potHeight) return;

    this.potForm.setValue(
      {
        name: this.pot.identifier,
        potType: this.pot.gearSubtype,
        height: this.pot.potHeight.toString(),
        width: this.pot.potHeight.toString(),
        length: this.pot.potLength.toString(),
        spacing: this.pot.spacing.toString(),
        holeSize: this.pot.escapeHoleSize.toString(),
        numHoles: this.pot.escapeHoleCount.toString()
      }
    );
  }

  compareFn(l1: LookupItem, l2: LookupItem): boolean {
    return l1 && l2 ? l1.code === l2.code : l1 === l2;
  }


  _forbidNonNumeric(control: AbstractControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''));
  }

}
